// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__37fQq","title":"Header_title__vRvM7","left":"Header_left__3OlXE","clinicName":"Header_clinicName__3BM0d"};